import { useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function usePortfolioMotion(root, ready, routeKey = '/') {
  useLayoutEffect(() => {
    if (!ready) return undefined;
    const media = gsap.matchMedia();
    media.add('(prefers-reduced-motion: no-preference)', () => {
      const select = gsap.utils.selector(root);
      const entrance = gsap.timeline({ defaults: { ease: 'power3.out' } });
      entrance.from(select('.header__logo, .header__menu-button'), { y: -24, autoAlpha: 0, duration: .75, stagger: .12 });
      if (select('.hero').length) {
        entrance
        .from(select('.hero__avatar-frame'), { y: 70, scale: 1.035, autoAlpha: 0, duration: 1.25 }, .12)
        .from(select('.hero__intro h1, .hero__intro p, .hero__statement'), { y: 30, autoAlpha: 0, duration: .95, stagger: .13 }, .38)
        .from(select('.hero__scroll'), { y: 12, autoAlpha: 0, duration: .6 }, .95);

      gsap.to(select('.hero__ambient'), {
        scale: 1.15, opacity: .65, duration: 4, repeat: -1, yoyo: true, ease: 'sine.inOut',
        scrollTrigger: { trigger: select('.hero')[0], start: 'top bottom', end: 'bottom top', toggleActions: 'play pause resume pause' },
      });
      gsap.from(select('.featured-projects__heading > *'), {
        y: 35, autoAlpha: 0, duration: .9, stagger: .15, ease: 'power3.out',
        scrollTrigger: { trigger: select('.featured-projects')[0], start: 'top 86%', once: true },
      });
      gsap.from(select('.project-card'), {
        y: 60, autoAlpha: 0, duration: 1, stagger: .10, ease: 'power3.out',
        scrollTrigger: { trigger: select('.featured-projects__cards')[0], start: 'top 92%', once: true },
      });
      }
      select('[data-reveal]').forEach((element) => {
        gsap.from(element, { y: 32, autoAlpha: 0, duration: .9, ease: 'power3.out',
          scrollTrigger: { trigger: element, start: 'top 93%', once: true } });
      });
      gsap.to(select('.contact__star'), { rotation: 90, ease: 'none',
        scrollTrigger: { trigger: select('.contact')[0], start: 'top bottom', end: 'bottom top', scrub: 1 } });
      ScrollTrigger.refresh();
    }, root);
    return () => media.revert();
  }, [root, ready, routeKey]);
}
